module.exports = __webpack_public_path__ + "static/media/loading-green.674a12de.gif";